import styled, { css } from "styled-components";

export const DefaultLoaderMain = styled.div`
  height: 100%;
  text-align: center;
  justify-content: center;
  display: flex;
`;

export const DefaultLoaderImage = styled.div`
  align-self: center;
`;

export const SVG = styled.svg`
  stroke: ${({ theme }) => theme.headerTextColor};
  width: 75px;
  height: 75px;
  ${(props) => props.width && css`
    width: ${props.width};
    height: ${props.width};
  `};
`;